import React, { useState, useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Dashborad from "./Dashborad";
import Profile from "./Profile";
import EnrolledCourse from "./EnrolledCourse";
import Reviews from "./Reviews";
import OrderHistory from "./OrderHistory";
import { AuthContext } from "../../../Context/AuthContext";
import Cookies from 'js-cookie';

const StudentDashboard = () => {
    const [activeSection, setActiveSection] = useState("dashboard");
    const { cookies } = useContext(AuthContext);
    const location = useLocation();
    const employeeName = cookies?.username || 'Guest';
    const navigate = useNavigate();
    // Get profile photo URL from cookie
    const profilePhotoUrl = Cookies.get('profile_photo_url');

    useEffect(() => {
        if (location.state?.section) {
            setActiveSection(location.state.section);
        }
    }, [location.state]);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        Cookies.remove('token'); // Remove token from cookies
        Cookies.remove('username'); 
        navigate('/');
    };

    return (
        <>
            <div className="rbt-page-banner-wrapper">
                {/* Start Banner BG Image  */}
                <div className="rbt-banner-image" />
                {/* End Banner BG Image  */}
            </div>
            {/* Start Card Style */}
            <div className="rbt-dashboard-area rbt-section-overlayping-top rbt-section-gapBottom">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            {/* Start Dashboard Top  */}
                            <div className="rbt-dashboard-content-wrapper">
                                <div
                                    className={`tutor-bg-photo height-350${profilePhotoUrl ? '' : ' bg_image bg_image--23'}`}
                                    style={
                                        profilePhotoUrl
                                            ? {
                                                backgroundImage: `url('${profilePhotoUrl}')`,
                                                backgroundSize: 'cover',
                                                backgroundPosition: 'center',
                                                filter: 'blur(2px)'
                                            }
                                            : {}
                                    }
                                />
                                {/* Start Tutor Information  */}
                                <div className="rbt-tutor-information">
                                    <div className="rbt-tutor-information-left">
                                        <div className="thumbnail rbt-avatars size-lg">
                                            <img  src={profilePhotoUrl} alt="Student" style={{ width: '120px', height: '120px', borderRadius: '50%', objectFit: 'cover' }} />
                                        </div>
                                        <div className="tutor-content">
                                            <h5 className="title">{employeeName}</h5>
                                            <ul className="rbt-meta rbt-meta-white mt--5">
                                                <li>
                                                    <i className="feather-book" />5 Courses Enroled
                                                </li>
                                                <li>
                                                    <i className="feather-award" />4 Certificate
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    {/* <div className="rbt-tutor-information-right">
                                        <div className="tutor-btn">
                                            <a className="rbt-btn btn-md hover-icon-reverse" href="#">
                                                <span className="icon-reverse-wrapper">
                                                    <span className="btn-text">Become an Instructor</span>
                                                    <span className="btn-icon">
                                                        <i className="feather-arrow-right" />
                                                    </span>
                                                    <span className="btn-icon">
                                                        <i className="feather-arrow-right" />
                                                    </span>
                                                </span>
                                            </a>
                                        </div>
                                    </div> */}
                                </div>
                                {/* End Tutor Information  */}
                            </div>
                            {/* End Dashboard Top  */}
                            <div className="row g-5">
                                <div className="col-lg-3">
                                    {/* Start Dashboard Sidebar  */}
                                    <div className="rbt-default-sidebar sticky-top rbt-shadow-box rbt-gradient-border">
                                        <div className="inner">
                                            <div className="content-item-content">
                                                <div className="rbt-default-sidebar-wrapper">
                                                    <div className="section-title mb--20">
                                                        <h6 className="rbt-title-style-2">Welcome, {employeeName}</h6>
                                                    </div>
                                                    <nav className="mainmenu-nav">
                                                        <ul className="dashboard-mainmenu rbt-default-sidebar-list">
                                                            <li>
                                                                <a href="#dashboard" 
                                                                   className={activeSection === "dashboard" ? "active" : ""}
                                                                   onClick={() => setActiveSection("dashboard")}>
                                                                    <i className="feather-home" />
                                                                    <span>Dashboard</span>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="#dashboard" 
                                                                   className={activeSection === "profile" ? "active" : ""}
                                                                   onClick={() => setActiveSection("profile")}>
                                                                    <i className="feather-user" />
                                                                    <span>My Profile</span>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="#dashboard" 
                                                                   className={activeSection === "enrolled" ? "active" : ""}
                                                                   onClick={() => setActiveSection("enrolled")}>
                                                                    <i className="feather-book-open" />
                                                                    <span>Enrolled Courses</span>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="#dashboard" 
                                                                   className={activeSection === "reviews" ? "active" : ""}
                                                                   onClick={() => setActiveSection("reviews")}>
                                                                    <i className="feather-star" />
                                                                    <span>Reviews</span>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="#dashboard" 
                                                                   className={activeSection === "orders" ? "active" : ""}
                                                                   onClick={() => setActiveSection("orders")}>
                                                                    <i className="feather-shopping-bag" />
                                                                    <span>Order History</span>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </nav>
                                                    <div className="section-title mt--40 mb--20">
                                                        <h6 className="rbt-title-style-2">User</h6>
                                                    </div>
                                                    <nav className="mainmenu-nav">
                                                        <ul className="dashboard-mainmenu rbt-default-sidebar-list">
                                                           
                                                            <li> <a onClick={handleLogout}>
                                                                    <i className="feather-log-out" />
                                                                    <span>Logout</span>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </nav>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* End Dashboard Sidebar  */}
                                </div>
                                <div id="dashboard" className="col-lg-9">
                                    <div className="rbt-dashboard-content bg-color-white rbt-shadow-box mb--60">
                                        {activeSection === "dashboard" && <Dashborad />}
                                        {activeSection === "profile" && <Profile />}
                                        {activeSection === "enrolled" && <EnrolledCourse />}
                                        {activeSection === "reviews" && <Reviews />}
                                        {activeSection === "orders" && <OrderHistory />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* End Card Style */}
            <div className="rbt-separator-mid">
                <div className="container">
                    <hr className="rbt-separator m-0" />
                </div>
            </div>
        </>
    );
};

export default StudentDashboard;
